import React, { useState } from "react";
import { Box } from "@mui/material";
import styles from "./emailComponent.module.scss";
import i18next from "i18next";
import FormikControl from "../formComponents/FormikControl";
import { Formik, Form } from "formik";
import _ from "lodash";
import FooterButtonSection from "../footerSection/FooterButtonSection";
import * as Yup from "yup";
import { generalValidationMessage } from "../../config/appConfig";
import PreviewEmailComponent from "./PreviewEmailComponent";
import {
  previewDealerBulkEmail,
  sendDealerBulkEmail,
} from "../../services/APIService";
import { useApiErrorModalContext } from "../../errorHandling/ApiErrorModalContext";
import PropTypes from "prop-types";

const EmailComponent = (props) => {
  const {
    selectionModel,
    setEmailOpen,
    setBulkActionMenuFlag,
    setSelectionModal,
    setSnackBarCustomMessage,
    setOpenSnackbar,
  } = props;
  const [preview, setPreview] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  const [buttonName, setButtonName] = useState("");
  const { setApiErrorModalState } = useApiErrorModalContext();

  const translatedGeneralValidationMessage = `${i18next.t(
    generalValidationMessage
  )}`;

  const validationSchema = Yup.object().shape({
    emailTitle: Yup.string().required(translatedGeneralValidationMessage),
    emailContent: Yup.string().required(translatedGeneralValidationMessage),
  });

  const handleSubmit = (values) => {
    if (buttonName === "send") {
      sendDealerBulkEmail({
        emailDescription: _.get(values, "emailTitle", ""),
        emailContent: _.get(values, "emailContent", ""),

        dealer_Ids: selectionModel,
      })
        .then((response) => {
          if (
            !_.isEmpty(_.get(response, "errorMessage", "")) ||
            _.get(response, "success", true) === false
          ) {
            _.set(response, "status", 200);

            setApiErrorModalState({ error: response });
          } else {
            setEmailOpen(false);
            setBulkActionMenuFlag(false);
            setSelectionModal([]);
            setSnackBarCustomMessage("Email succesvol verstuurd");
            setOpenSnackbar(true);
          }
        })
        .catch((err) => {
          setApiErrorModalState({ error: err });
        });
    } else if (buttonName === "preview") {
      previewDealerBulkEmail({
        emailDescription: _.get(values, "emailTitle", ""),
        emailContent: _.get(values, "emailContent", ""),
      })
        .then((response) => {
          if (
            !_.isEmpty(_.get(response, "errorMessage", "")) ||
            _.get(response, "success", true) === false
          ) {
            _.set(response, "status", 200);

            setApiErrorModalState({ error: response });
          } else {
            setPdfUrl(_.get(response, "pdfUrl", ""));
            setPreview(true);
          }
        })
        .catch((err) => {
          setApiErrorModalState({ error: err });
        });
    } else if (buttonName === "edit") {
      setPreview(false);
    } else {
      setButtonName("");
    }
  };

  return (
    <Box
      className={styles.emailComponentMainWrapper}
      data-testid="EmailComponent"
    >
      <Formik
        initialValues={{
          emailTitle: "",
          emailContent: "",
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          setFieldTouched,
          setFieldValue,
          touched,
          errors,
          handleSubmit,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Box className={styles.emailComponentWrapper}>
                <span className={styles.selectText}>
                  {i18next.t("You have")}
                  <span className={styles.count}>
                    {selectionModel?.length < 10
                      ? ` (0${selectionModel?.length}) `
                      : ` (${selectionModel?.length}) `}
                  </span>
                  {i18next.t(" selected dealers")}
                </span>
                {!preview ? (
                  <Box className={styles.inputBoxWrapper}>
                    <Box className="textboxDoubleWraper">
                      <FormikControl
                        control="textfield"
                        type="text"
                        hiddenLabel
                        size="small"
                        variant="filled"
                        className={`input-grp__box`}
                        label={i18next.t("Title")}
                        id="emailTitle"
                        name="emailTitle"
                        placeholder={i18next.t("Enter the mail title here")}
                        value={values.emailTitle}
                        onChange={(e) => {
                          let value = _.get(e, "target.value", "");
                          setFieldTouched("emailTitle", false);
                          setFieldValue("emailTitle", value);
                        }}
                        error={touched?.emailTitle && errors?.emailTitle}
                        errorMessage={errors?.emailTitle}
                      />
                    </Box>
                    <Box className={"emailContent"}>
                      <FormikControl
                        control="textarea"
                        type="text"
                        hiddenLabel
                        size="small"
                        variant="filled"
                        className={`input-grp__box`}
                        label={i18next.t("Mail content")}
                        id="emailContent"
                        name="emailContent"
                        placeholder={i18next.t(
                          "Enter the content for mail here..."
                        )}
                        value={values.emailContent}
                        onChange={(e) => {
                          let value = _.get(e, "target.value", "");

                          setFieldTouched("emailContent", false);
                          setFieldValue("emailContent", value);
                        }}
                        error={touched.emailContent && errors.emailContent}
                        errorMessage={errors?.emailContent}
                      />
                    </Box>
                  </Box>
                ) : (
                  <PreviewEmailComponent pdfUrl={pdfUrl} />
                )}
              </Box>

              <Box className={styles.buttonWrapper}>
                <FooterButtonSection
                  btnlist={[
                    {
                      title: preview ? "Edit" : "Preview",
                      iconStyle: "",
                      buttonType: "muibtn-secondary-with-icon",
                      attriType: "button",
                      withIcon: false,
                      showCountSection: false,
                      count: 0,
                      handleClick: () => {
                        preview
                          ? setButtonName("edit")
                          : setButtonName("preview");
                        handleSubmit(values);
                      },
                      isDisabled: false,
                    },
                    {
                      title: "Send email",
                      iconStyle: "",
                      buttonType: "muibtn-primary-with-icon",
                      attriType: "button",
                      withIcon: false,
                      showCountSection: false,
                      count: 0,
                      handleClick: () => {
                        setButtonName("send");
                        handleSubmit(values);
                      },
                      isDisabled: false,
                    },
                  ]}
                />
              </Box>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default EmailComponent;
EmailComponent.propTypes = {
  selectionModel: PropTypes.any,
  setEmailOpen: PropTypes.any,
  setBulkActionMenuFlag: PropTypes.any,
  setSelectionModal: PropTypes.any,
  setSnackBarCustomMessage: PropTypes.any,
  setOpenSnackbar: PropTypes.any,
};
